import { render, staticRenderFns } from "./historySearch.vue?vue&type=template&id=fdd9fa84&scoped=true"
import script from "./historySearch.vue?vue&type=script&lang=js"
export * from "./historySearch.vue?vue&type=script&lang=js"
import style0 from "./historySearch.vue?vue&type=style&index=0&id=fdd9fa84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd9fa84",
  null
  
)

export default component.exports